import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import styled from "styled-components";

const ConsentInfo = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 8px;

  a {
    margin-left: 6px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.link};
  }

  ul {
    margin: 6px 0;
    padding-left: 24px;
  }

  ${TertiaryHeader} {
    font-size: ${({ theme }) => theme.fonts.body.fontSize};
    font-weight: ${({ theme }) => theme.fonts.body.fontWeight};
    line-height: ${({ theme }) => theme.fonts.body.lineHeight};
  }
`;

export default ConsentInfo;
